// Imports
import { useStateValue } from 'src/modules/_global/jsx/store';
import { ReactDetailedReport } from 'src/modules/ReactDetailedReport/jsx/component.jsx';
import { returnEmailLink,sendUserData } from 'src/lib/utils.js';

// The Navigation at the bottom of the page containing the Next and Previous buttons

export const ReactFooterNav = () => {

    const [{ globalText, userData, controlData, modalData, questionSectionData }, dispatch] = useStateValue();

    // var firstBtn = document.querySelector('.br-app-main-content__input-group .br-app-btn:first-child');

    // if(typeof firstBtn !== 'undefined' && firstBtn !== null) {
    //     console.log('test111');
       
    //     if(firstBtn.length > 0) { 
    //         setTimeout(function() { 
    //             firstBtn.focus();
    //         }, 1);
    //     }
    // }


    // Click handler for the Previous button 
    const footerNavPrevClickHandler = (event) => {
        event.preventDefault();
        dispatch({
            type: 'footerNavClick',
            value: 'prev'
        });
    }

    // Click handler for the Next button 
    const footerNavNextClickHandler = (event) => {
        event.preventDefault();
        dispatch({
            type: 'footerNavClick',
            value: 'next'
        });
    }

    const validationfooterNavNextClickHandler = (event) => {
        event.preventDefault();
        let valid = true;
        let firstError;
        const questions = document.querySelectorAll('.br-app-main-content__contents__question');

        questions.forEach(function(question, i){
            if(!question.querySelector('.br-app-btn.selected')) {
                if (valid == true) {
                    firstError = question;
                }
                valid = false;
                question.querySelector('.br-app-main-content__error').classList.remove('hidden');
                console.log('invalid');
            } else {
                question.querySelector('.br-app-main-content__error').classList.add('hidden');
            }
        });

        if (valid) {
            dispatch({
                type: 'footerNavClick',
                value: 'next'
            });
        } else {
            window.scrollTo({
                top: firstError.offsetTop
            });
        }
    }

    // Click handler for the returning to DA Hub
    const detailHubClickHandler = (event) => {
        event.preventDefault();
        
        let hubId = controlData.currentItem.hubId;

        if (hubId) {
            dispatch({
                type: 'mainNavClick',
                value: { assetID: hubId }
            });
        }
        
    }

    // Click handler for opening the progress report modal
    const reportModalHandler = (event) => {
        event.preventDefault();

        let sectionId = controlData.currentItem.assetID;
        let modalContent = <ReactDetailedReport sectionId={sectionId} />;

        let appNameString = globalText.gaAppName;
        let appLabel = `View progress report - ${controlData.currentItem.headerText}`;

         // fix for window.dataLayer undefined in Firefox
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({"event": "interaction", "target": appNameString, "action": "button click", "label": (appLabel)}); 

        dispatch({
            type: 'showProgressReportModal',
            value: { modalContent: modalContent}
        });
    }

    // Returns the internal text for the Nav buttons
    const returnNavBtnText = (buttonText, pageName) => {
        // Structure of nav button internals
        return (
            <>
                <span className="br-app-main-content__buttons__link__text">
                    {buttonText}
                </span>
                <span className="br-app-main-content__buttons__link__page">
                    {pageName}
                </span>
            </>
        );
    };

    // If there is a previous item available return it
    const returnPrevBtn = () => {

        // if we are on the detailed overview, hide the previous button
        if (controlData.currentItem.pageType === "detailedOverview") {
            return;
        }


        let buttonText = globalText.prevButtonText;
        let wrapperClass = '';
        let clickHandler = footerNavPrevClickHandler;
         
        

        // if this is a questions section within the detailed assessment, replace Prev with a
        // button to return the user to the Detailed Assessment Hub
        if (controlData.currentItem.pageType === "questionSection") {
            if (controlData.currentItem.assessmentType === "detailed") {
                buttonText = globalText.detailedAssessmentReturnLabel;
                clickHandler = detailHubClickHandler;
            }
        }

        if (controlData.prevItem !== null) {
            let prevBtn = returnNavBtnText(buttonText, controlData.prevItem.navName);

            return (
                <div className={"br-app-main-content__buttons__prev" + wrapperClass}>
                    <a onClick={clickHandler} href="#" className="br-app-main-content__buttons__link">
                        {prevBtn}
                    </a>
                </div>
            );
        }
    }

    // If ther is a next item available return it, else return report button
    const returnNextBtn = () => {
        let showNextBtn = true;
        let buttonText = globalText.nextButtonText;
        let wrapperClass = '';
        let clickHandler = footerNavNextClickHandler;

        //questions need to be answered to progress
        if (controlData.currentItem.pageType === "question") {

            //if this is a three answer question and the user has answered it
            if (controlData.currentItem.qType === "threeAnswers" && userData.questionResponses[controlData.currentItem.assetID] == null) {
                showNextBtn = false;
            }
            //if this is a four answer question and the user has answered it
            if (controlData.currentItem.qType === "fourAnswers" && userData.questionResponses[controlData.currentItem.assetID] == null) {
                showNextBtn = false;
            }
        }

        if (controlData.currentItem.pageType === "questionSection") {
            clickHandler = validationfooterNavNextClickHandler;
        }

        // if this is the home page, and required select fields aren't answered
        if (controlData.currentItem.pageType === "homePage") {
           
            if(typeof(controlData.currentItem.homeSelectItems) !== 'undefined'){
                let selectFields = controlData.currentItem.homeSelectItems;
                buttonText = globalText.startButtonText;
                clickHandler = homeNavNextClickHandler;
               // wrapperClass = ' br-app-main-content__buttons__next--left';
                
                selectFields.forEach(item => {
                    if (item.required === "true") {
                        if(typeof(userData.questionResponses) !== 'undefined') {
                            if (!userData.questionResponses.hasOwnProperty(item.assetID)) {
                                showNextBtn = false;
                            }
                        }
                    }
                });
            }
            buttonText = globalText.startButtonText;
                clickHandler = homeNavNextClickHandler;

            
        }

        // if this is a questions section within the detailed assessment, replace Next with
        // a 'View Progress Report' modal button
        if (controlData.currentItem.pageType === "questionSection") {
            if (controlData.currentItem.assessmentType === "detailed") {

                //if the user has answered 100% in the rapid section do not show the report modal button
               // console.log("hereeeee",controlData.currentItem.linkedSection,getUserResultsOfRapidQuestionSection(controlData.currentItem.linkedSection))
               if (controlData.currentItem.linkedSection.length) { 
                    if( getUserResultsOfRapidQuestionSection(controlData.currentItem.linkedSection) === 100){
                        return null;
                    }
               }


                buttonText = globalText.detailedAssessmentReportLabel;
                wrapperClass = ' br-app-main-content__buttons__modal';
                clickHandler = reportModalHandler;
            }
        }

        



        //if there is a next item eg. we are not at the end of the quiz and we are not preventing progress show the next button
        if (controlData.nextItem !== null) {
            let nextBtn = returnNavBtnText(buttonText, controlData.nextItem.navName);

            //show a disabled state when we are waiting for a user response
            if (showNextBtn !== true) {
                return (
                    <div className={"br-app-main-content__buttons__next disabled" + wrapperClass}>
                        <span className="br-app-main-content__buttons__link">
                            {nextBtn}
                        </span>
                    </div>
                );
            }

            // Default clickable button
            return (
                <div className={"br-app-main-content__buttons__next" + wrapperClass}>
                    <a onClick={clickHandler} href="#" className="br-app-main-content__buttons__link">
                        {nextBtn}
                    </a>
                </div>
            );
        }
 
        // if we are at the end of the report, show a restart button
        return <button className="br-app-btn br-app-btn__restart" onClick={showConfirmRestartModal}>{globalText.modalRestartBtnLabelRestart}</button>
    }

    // Dispatches event to show the confirm restart modal 
    const showConfirmRestartModal = () => {
        modalData.callback = dispatchRestartEvent;
        dispatch({
            type: 'showConfirmRestartModal',
            value: 'no-modal',
            callback: dispatchRestartEvent
        });
    }

    // Dispatches event to restart the app
    const dispatchRestartEvent = () => {
        dispatch({
            type: 'restart',
            value: 'no-modal'
        });
    }

    // Returns the classes for the main nav content
    const returnClasses = () => {
        let classes = "br-app-main-content__buttons__prev-next";

        // If we are hiding the page labels add the class
        if (globalText.showNextPrevLabels === "false") {
            classes += " hide__prev-next__labels";
        }

        return classes;
    }








    // Get 
    const getRapidQsectionFromAssetID = (rQsectionAssetID) => {
        //filter out all but the rapid sections
        let rapidQsections = Object.values(questionSectionData).filter(
            (item) => {
                return item.assessmentType == "rapid";
            }
        )
        //find the rapid section by assetId from the passed parameter
        let rapidSection = rapidQsections.find((item) =>{
            return item.assetID == rQsectionAssetID;
        })

        return rapidSection;
    }

    // Get percentage score for the linked Rapid Assessment section
    const getUserResultsOfRapidQuestionSection = (rQsectionAssetID) => {
        let rapidQsection = getRapidQsectionFromAssetID(rQsectionAssetID);
        
        let sectionQuestions = rapidQsection.children;       
        let noOfQuestions = sectionQuestions.length;
        let totalScore = 0;
        sectionQuestions.forEach(question => {
            let rQassetID = question.assetID;
            let score = userData.questionResponses[rQassetID];

            if (score === 0) {
                totalScore++;
            } else if (score === 3) {
                noOfQuestions--;
            }
        });

        let percentage = totalScore / noOfQuestions * 100;
       // console.log("totalScore for section:",rapidQsection.navName ,totalScore);
        //console.log("percentage score for section:",rapidQsection.navName ,percentage);

        return percentage;
    }






    //------ data submission 

    // Click handler for the Next button 
    const homeNavNextClickHandler = (event) => {
        sendUserDataAfterHomePageClick()
        footerNavNextClickHandler(event);
        
    }

    const sendUserDataAfterHomePageClick = () => {
      /*  if(controlData.hasSubmittedContent === false){
            //sendUserData();
            sendUserData(globalText,userData,sendUserDataSuccess,sendUserDataFailure);
        }else{*/
            // if we have submitted the data, but it has changed submit again
            let emailLink = returnEmailLink(userData);      
           // console.log(controlData.submittedContentStrings); 
           // console.log(emailLink);
           // console.log(controlData.submittedContentStrings.indexOf(emailLink))
             // if(controlData.submittedContentStrings !== emailLink){
            
            
             if(controlData.submittedContentStrings.indexOf(emailLink) == -1){
                //sendUserData();
                controlData.submittedContentString = emailLink;
                sendUserData(globalText,userData,sendUserDataSuccess,sendUserDataFailure);
                //console.log("submitting");
            }else{
                //console.log("already submitted");
            }
       // }
    }

    // success for sendUserData
    const sendUserDataSuccess = () => {
        let emailLink = returnEmailLink(userData);
        dispatch({
            type: 'userDataSubmitted',
            value: emailLink        
        });
    }

    // fail for sendUserData - we can ignore it
    const sendUserDataFailure = () => {
        console.log("Data Sending Failed")
    }

    //------ data submission 





    // Component render
    return (
        <div className={returnClasses()}>
            { returnNextBtn()}
            { returnPrevBtn()}
        </div>
    );
};


